import React from "react";
import { assetUrl } from "../../helpers";

/**
 * Renders an uploaded icon, or nothing when there is none.
 *
 * Amenity, attribute and voucher-category icons are optional uploads and are
 * frequently empty. Rendering `<img src="">` makes the browser resolve the
 * current page URL, fail, and paint the alt text instead — which is why the
 * settings lists showed truncated words like "Park" and "Wi-F" where an icon
 * should be. A missing icon should simply take up its space quietly.
 */
export const IconImage = ({ src, alt, size = 30, placeholder = true }) => {
  const missing = !src || (typeof src === "string" && src.trim() === "");

  if (missing) {
    if (!placeholder) return null;
    return (
      <span
        aria-label={alt}
        title={alt}
        style={{
          display: "inline-block",
          width: size,
          height: size,
          borderRadius: 6,
          background: "rgba(255,255,255,0.08)",
          border: "1px dashed rgba(255,255,255,0.18)",
        }}
      />
    );
  }

  return (
    <img
      src={assetUrl(src)}
      alt={alt}
      style={{ width: size }}
      // If an upload later 404s, fall back to the same quiet placeholder
      // rather than the browser's broken-image treatment.
      onError={(event) => {
        event.currentTarget.style.visibility = "hidden";
      }}
    />
  );
};

export default IconImage;
